
































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */


/**
 * Components
 */


/**
 * API
 */

import { GetCurrentUserResponse } from "@/api/users/get-current-user.response";

/**
 * Types
 */

/**
 * VueX Modules
 */
const profileModule = namespace("profile");

/**
 * User page.
 */
@Component
export default class UserPage extends Vue {
	/// Injections

	/// Properties

	/// Attributes
	isLoading = false;
	isDragging = false;

	/// VueX Modules
	@profileModule.State("userDetails")
	userDetails!: GetCurrentUserResponse;

	
	
}
